import Image from "@/components/Atoms/Image";
import tw, { styled } from "twin.macro";

export const StyledButtonPrevContainer = styled.div`
  ${tw`absolute z-10 left-0 top-0  w-max h-full grid place-content-center invisible  medium:visible min-[1410px]:(left-0 block h-max top-[30%] large:(-left-sm) )`}
`;

export const StyledButtonNextContainer = styled.div`
  ${tw`absolute z-10 right-0 top-0  w-max h-full grid place-content-center invisible  medium:visible min-[1410px]:(right-0 block h-max top-[30%] ) large:(-right-sm)`}
`;

export const StyledWrapperSwiperBanner = styled.div`
  ${tw`medium:(rounded-xxl)`}

  & div.swiper-slide {
    ${tw`w-min h-auto!`};
  }
`;

export const StyledWrapperRoot = styled.section`
  ${tw`w-full mx-auto max-w-screen-large relative medium:px-m large:px-0`}

  .swipperNavButtonBanners {
    ${tw`opacity-50  transition-opacity duration-300 ease-in-out`}
  }
  &:hover .swipperNavButtonBanners {
    ${tw`medium:(opacity-100 pointer-events-auto)`}
  }
`;
export const StyledWrapperGradient = styled.section`
  ${tw`w-full pt-4 flex flex-col gap-3  medium:(pt-7) large:(pt-10 ) relative`}

  .swipperNavButtonBanners {
    ${tw`opacity-0 pointer-events-none transition-opacity duration-300 ease-in-out`}
  }
  &:hover .swipperNavButtonBanners {
    ${tw`medium:(opacity-100 pointer-events-auto)`}
  }

  @property --myColor1 {
    syntax: "<color>";
    initial-value: transparent;
    inherits: false;
  }
  --myColor2: transparent;

  background: linear-gradient(var(--myColor1) 0%, var(--myColor2) 81%);
  transition: --myColor1 0.3s;

  &:has(.hubsSection:hover) {
    .swipperNavButtonBanners {
      ${tw`opacity-0 pointer-events-none`}
    }
  }
`;

export const StyledSwiperSlide = styled.div`
  ${tw`w-auto medium:(max-w-full ml-0 mr-0) max-h-[15.625rem]`}
`;

export const StyledBanner = styled.a`
  ${tw`w-full md:(max-w-screen-xl mx-auto) relative`}
`;

export const StyledBannerImage = styled(Image)`
  ${tw`rounded-xxl w-full object-fill min-h-[8.125rem] h-full medium:(min-h-[12.5rem]) large:(h-[15.625rem])`}
`;
export const StyledSkeletonBanner = styled.div`
  ${tw`rounded-xxl w-full  object-fill h-[8.125rem] medium:(h-[12.5rem]) large:(h-[15.625rem]) px-m medium:px-0 relative overflow-hidden`}
`;
